module.exports = __webpack_public_path__ + "favicon.ico";


//////////////////
// WEBPACK FOOTER
// ./icons/favicon.ico
// module id = qUS6
// module chunks = 1